module.exports = __webpack_public_path__ + "img/denti_i_logo_seoul.f4d66f19.png";